export default __webpack_public_path__ + "static/media/W_Forms.274101d5.png";